import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-settings-account',
  templateUrl: './settings-account.component.html',
  styleUrls: ['./settings-account.component.scss']
})
export class SettingsAccountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
